import React, { useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import { TooltipOptionItem, TooltipOptionListItem } from '@luigiclaudio/ga-baseline-ui/tooltip';
import useCopied from '../../utils/useCopied';

const ColorTooltipOptionValue = ({ colorValue, hideTooltip }) => {
    const ref = useRef();
    const theme = useContext(ThemeContext);
    const { copyToClipboard } = useCopied();

    const colorValueCode = colorValue.slice(1);

    return (
        <TooltipOptionListItem>
            <TooltipOptionItem
                ref={ref}
                label={colorValue}
                icon={theme.site.feedback.icon.copy}
                onClick={() => {
                    copyToClipboard({ valueCopied: colorValueCode, labelCopied: colorValue });
                    hideTooltip();
                }}
            />
        </TooltipOptionListItem>
    );
};

ColorTooltipOptionValue.propTypes = {
    colorValue: PropTypes.string.isRequired,
    hideTooltip: PropTypes.func,
};

ColorTooltipOptionValue.defaultProps = {
    hideTooltip: () => {},
};

export default ColorTooltipOptionValue;
